import React, {Component} from 'react'

export class SecondaryTitle extends Component {
    render() {
        return (
            <h3 className={`${this.props.className} font-regular text-xl text-center uppercase text-green-comelit`}>{this.props.children}</h3>
        )
    }
}